import React from 'react';
import { errorMsgToHtml } from '@/util';
import { usePollSavedQueryCacheStatus } from '@/features/query-builder/savedQueriesApiSlice';
import AjaxSpinner from '../components/AjaxSpinner';
import flex from '../css/module/flex.css';
import { CACHED_VIEW_LOADING } from '../constants/test-ids';

const CachedViewRefresher = () => {
  const { isUninitialized, isLoading, _error_msg, totalRowCount } =
    usePollSavedQueryCacheStatus();

  if (isUninitialized) {
    return null; // nothing to show
  }
  if (isLoading) {
    return (
      <div>
        <div
          className="cachedViewRefresherNewWorld"
          data-testid={CACHED_VIEW_LOADING}
        >
          <div className="margin-right-10">
            <AjaxSpinner small />
          </div>
          <span>
            Preparing <b>{totalRowCount || 'all'} rows</b> in case you want to
            export the results.
          </span>
        </div>
      </div>
    );
  }
  if (_error_msg) {
    return (
      <div>
        <div
          className={`${flex.alignItemsCenter} cachedViewRefresherNewWorld cachedViewRefresherNewWorld-error`}
        >
          <span style={{ whiteSpace: 'nowrap' }}>
            Problem preparing export:&nbsp;
          </span>
          <span>{errorMsgToHtml(_error_msg)}</span>
          {/* {retryUsed ? null : ( */}
          {/*  <button */}
          {/*    type="button" */}
          {/*    className={`${buttons.btn} margin-left-10`} */}
          {/*    onClick={onRetryView(lastLoadedView)} */}
          {/*  > */}
          {/*    retry */}
          {/*  </button> */}
          {/* )} */}
        </div>
      </div>
    );
  }
  return null;
};

export default CachedViewRefresher;

// const mapStateToProps = (state) => {
//   return {
//     lastLoadedView: state.views.lastLoadedView,
//     statusLoaded: state.views.statusLoaded,
//     retryUsed: state.views.retryUsed,
//     totalRowCount: state.rows.totalRowCount,
//     errorMsg: state.views.errorMsg,
//   };
// };
